var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 24,
    viewBox: "0 0 29 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8319 0.25C15.8654 0.25 15.0819 1.0335 15.0819 2C15.0819 2.9665 15.8654 3.75 16.8319 3.75C21.3882 3.75 25.0819 7.44365 25.0819 12C25.0819 16.5564 21.3882 20.25 16.8319 20.25C12.2755 20.25 8.58189 16.5564 8.58189 12C8.58189 11.053 8.70783 10.4319 8.92262 9.64404L10.0484 11.9272C10.4148 12.6703 11.3141 12.9756 12.0571 12.6092C12.8001 12.2428 13.1055 11.3435 12.7391 10.6005L9.78282 4.60501L9.11945 3.25967L7.77411 3.92303L1.77862 6.87932C1.03561 7.24569 0.730276 8.14502 1.09664 8.88803C1.46301 9.63104 2.36234 9.93637 3.10535 9.57001L5.65339 8.31361C5.34801 9.40999 5.08189 10.5435 5.08189 12C5.08189 18.4893 10.3425 23.75 16.8319 23.75C23.3212 23.75 28.5819 18.4893 28.5819 12C28.5819 5.51065 23.3212 0.25 16.8319 0.25Z",
    fill: "#888888"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReload);
export default __webpack_public_path__ + "static/media/reload.595586da89f0b26c26091575270cd0a6.svg";
export { ForwardRef as ReactComponent };